<template>
  <div>
    <!-- ABOUT HEADER -->
    <h2 class="display-4 fw-bolder text-uppercase mt-5 text-dark" id="about-me">
      About me
    </h2>
    <!--DIVIDER LINE -->
    <div class="divider-custom">
      <div class="divider-custom-line" />
      <div class="divider-custom-icon">
        <i class="fas fa-star fs-1" style="color: #222831"></i>
      </div>
      <div class="divider-custom-line" />
    </div>
    <!-- ABOUT CONTENT -->
    <about-body class="container-fluid"></about-body>
  </div>
</template>

<script>
import AboutBody from "./AboutBody.vue";

export default {
  name: "about-content",
  components: { AboutBody },
};
</script>

<style>
.divider-custom {
  margin: 1.25rem 0 1.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divider-custom .divider-custom-line {
  width: 100%;
  max-width: 10rem;
  height: 0.3rem;
  background-color: #222831;
  border-radius: 1rem;
  border-color: #222831 !important;
}
</style>